import { useRef, useEffect } from "react";
import Popover from "../popover";

import style from "./style.module.scss";
import type { DropdownMenuProps, DropdownMenuItemProps } from "../../types";

function DropdownMenu({ triggerRef, open, onClose, children }: DropdownMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;

    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  return (
    <Popover anchorRef={triggerRef} open={open} placement="center" className={style.menu}>
      <div ref={menuRef}>{children}</div>
    </Popover>
  );
}

export function DropdownMenuItem({ icon, onClick, children }: DropdownMenuItemProps) {
  return (
    <button type="button" className={style.menuItem} onClick={onClick}>
      {icon}
      {children}
    </button>
  );
}

export default DropdownMenu;
